import React from 'react';
import { Form } from 'react-bootstrap';

/**
 * Bootstrap checkbox with one label on each side.
 * Props:
 * - name: Input name and id.
 * - leftLabel: Label on the left of the checkbox.
 * - leftLabel: Label on the right of the checkbox.
 * Other props: See Form.Check.
 */
export default function FormCheckDoubleLabel(props) {
    const { name, leftLabel, rightLabel, ...otherProps } = props;
    return <>
        <label htmlFor={name}>{leftLabel}</label>
        <Form.Check
            label={rightLabel}
            id={name} name={name}
            {...otherProps}
            style={{ marginLeft: "0.5rem", display: "inline-block" }} />
    </>;
}

FormCheckDoubleLabel.defaultProps = {
    type: "switch",
    value: "true"
}
